<template>
  <div class="calc-result">
    <div class="calc-result__wrp">
      <slot />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.calc-result {
  @include flex-container(column, center, center);

  background-color: var(--color-sky-lightest);

  border-radius: 24px;

  padding: 24px;

  @include bigMobile() {
    border-radius: 16px;

    padding: 32px;
  }

  &__wrp {
    max-width: 440px;
    width: 100%;

    @include flex-container(column);

    gap: 8px;
  }
}
</style>
